import React, { useState, memo } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface Module {
  emoji: string;
  title: string;
  subtitle: string;
  pages: string;
  items: {
    icon: string;
    text: string;
  }[];
}
const modules: Module[] = [{
  emoji: '📖',
  title: 'CAPITOLO 1 — Farmacologia Senza Panico',
  subtitle: 'Dosaggi, Farmaci e Protocolli che Userai Davvero',
  pages: '~60 pagine',
  items: [{
    icon: '💊',
    text: 'Le 20 molecole che ogni studente deve conoscere a memoria'
  }, {
    icon: '🐕🐈',
    text: "Differenze chiave cane vs. gatto (ciò che può fregarti all'esame e in clinica)"
  }, {
    icon: '⚖️',
    text: 'Come calcolare i dosaggi senza sbagliare sotto pressione'
  }, {
    icon: '🚫',
    text: 'Interazioni farmacologiche più comuni e pericolose'
  }, {
    icon: '📋',
    text: 'Tabella riassuntiva scaricabile: farmaci x specie x dose x via di somministrazione'
  }, {
    icon: '🧠',
    text: 'Trucco mnemonico per ricordare antibiotici, FANS e anestetici'
  }]
}, {
  emoji: '🩺',
  title: "CAPITOLO 2 — L'Esame Fisico Perfetto",
  subtitle: "Dall'Animale Reale alla Diagnosi Presuntiva",
  pages: '~60 pagine',
  items: [{
    icon: '👁️',
    text: "Ordine sistematico dell'esame fisico che non fallisce mai"
  }, {
    icon: '📝',
    text: "Checklist scaricabile per un'anamnesi completa"
  }, {
    icon: '❤️',
    text: 'Come interpretare frequenza cardiaca, respiratoria e temperatura per specie'
  }, {
    icon: '🔴',
    text: 'Segnali di allarme che non puoi ignorare in visita'
  }, {
    icon: '🎯',
    text: 'Dal segno clinico alla diagnosi differenziale: come pensare da clinico'
  }, {
    icon: '📸',
    text: 'Guida visiva dei reperti normali vs. patologici'
  }]
}, {
  emoji: '🚨',
  title: 'CAPITOLO 3 — Emergenze e Primo Soccorso',
  subtitle: 'Protocollo Passo per Passo',
  pages: '~60 pagine',
  items: [{
    icon: '⏱️',
    text: 'I primi 5 minuti: cosa fare quando arriva un paziente critico'
  }, {
    icon: '🫀',
    text: "RCP veterinaria aggiornata (tecnica, ritmo, farmaci d'emergenza)"
  }, {
    icon: '🐍',
    text: 'Intossicazioni più frequenti in cani e gatti: cosa fare e cosa NON fare'
  }, {
    icon: '🩸',
    text: 'Gestione dello shock: tipi, diagnosi rapida e trattamento iniziale'
  }, {
    icon: '🌡️',
    text: 'Colpo di calore, ipotermia e convulsioni: azione immediata'
  }, {
    icon: '📋',
    text: 'Scheda tascabile per le emergenze (formato stampabile)'
  }]
}, {
  emoji: '🔬',
  title: 'CAPITOLO 4 — Laboratorio Clinico per Studenti',
  subtitle: 'Interpreta i Risultati come un Professionista',
  pages: '~60 pagine',
  items: [{
    icon: '🧪',
    text: 'Emocromo completo: cosa ti dice ogni valore e quando preoccuparti'
  }, {
    icon: '💧',
    text: 'Biochimica ematica di base: fegato, rene e pancreas in numeri'
  }, {
    icon: '🔍',
    text: 'Sedimento urinario: guida visiva per non confondere nulla'
  }, {
    icon: '📊',
    text: 'Come leggere un referto di laboratorio con criterio clinico'
  }, {
    icon: '⚡',
    text: "Errori più comuni nel prelievo e nell'interpretazione dei campioni"
  }, {
    icon: '🗂️',
    text: 'Valori di riferimento per specie in tabella comparativa'
  }]
}, {
  emoji: '🐾',
  title: 'CAPITOLO 5 — Atlante Visivo di Razze e Malattie Prevalenti',
  subtitle: '',
  pages: '~60 pagine',
  items: [{
    icon: '🐶',
    text: 'Razze ad alto rischio e le loro malattie predisponenti più comuni'
  }, {
    icon: '🐱',
    text: 'Malattie infettive feline che ogni studente deve padroneggiare'
  }, {
    icon: '🐇🐹',
    text: 'Introduzione alle specie non convenzionali: segni clinici di base'
  }, {
    icon: '🌍',
    text: 'Malattie prevalenti in Italia ed Europa (Leishmaniosi, Ehrlichia, Parvovirus, Filariosi)'
  }, {
    icon: '🗺️',
    text: 'Mappa delle malattie per regione geografica'
  }, {
    icon: '📷',
    text: 'Immagini cliniche commentate di presentazioni tipiche'
  }]
}, {
  emoji: '🎓',
  title: "CAPITOLO 6 — Dall'Aula alla Clinica",
  subtitle: 'Come Sopravvivere (e Brillare) nei Tuoi Primi Tirocini',
  pages: '~60 pagine',
  items: [{
    icon: '😰',
    text: 'La sindrome dello studente in clinica: come gestire la paura di sbagliare'
  }, {
    icon: '🗣️',
    text: 'Come comunicare con il professionista responsabile senza fare brutta figura'
  }, {
    icon: '👐',
    text: 'Tecniche di contenzione e gestione del paziente senza farti male né farne a lui'
  }, {
    icon: '💉',
    text: 'Vie di somministrazione: EV, IM, SC, IO — tecnica corretta illustrata'
  }, {
    icon: '📓',
    text: 'Come scrivere una cartella clinica che ti faccia sembrare professionale'
  }, {
    icon: '🤝',
    text: "Come trattare il proprietario dell'animale: linguaggio, empatia e limiti"
  }]
}];
export function Modules() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="w-full py-16 px-4 bg-white" data-id="element-162">
      <div className="max-w-4xl mx-auto" data-id="element-163">
        <div className="text-center mb-10" data-id="element-164">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-900" data-id="element-165">
            Carrera Veterinaria 360 è stato creato per risolvere tutto questo.
          </h2>
          <p className="mt-3 text-slate-600 max-w-2xl mx-auto" data-id="element-166">
            6 capitoli che collegano la teoria che vedi all'università con ciò
            che farai davvero in clinica.
          </p>
        </div>

        <div className="space-y-3" data-id="element-167">
          {modules.map((m, i) => {
          const isOpen = openIdx === i;
          return <div key={i} className={`rounded-xl border-2 overflow-hidden transition-all duration-300 ${isOpen ? 'bg-green-600 border-green-700 text-white shadow-xl shadow-green-200' : 'bg-white border-slate-200 hover:border-green-300'}`} data-id="element-168">
                <button onClick={() => setOpenIdx(isOpen ? null : i)} className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-169">
                  <div className="flex items-start gap-3 flex-1" data-id="element-170">
                    <span className="text-2xl" data-id="element-171">{m.emoji}</span>
                    <div data-id="element-172">
                      <h3 className={`font-extrabold text-base sm:text-lg leading-tight ${isOpen ? 'text-white' : 'text-slate-900'}`} data-id="element-173">
                        {m.title}
                      </h3>
                      {m.subtitle && <p className={`text-sm mt-0.5 ${isOpen ? 'text-green-50' : 'text-slate-600'}`} data-id="element-174">
                          {m.subtitle}
                        </p>}
                      <span className={`inline-block mt-1 text-xs font-semibold ${isOpen ? 'text-green-100' : 'text-green-700'}`} data-id="element-175">
                        {m.pages}
                      </span>
                    </div>
                  </div>
                  <ChevronDownIcon className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-white' : 'text-slate-400'}`} data-id="element-176" />
                </button>

                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-177">
                  <div className="overflow-hidden" data-id="element-178">
                    <ul className="px-5 pb-5 pt-0 space-y-2.5 border-t border-green-500/30" data-id="element-179">
                      {m.items.map((item, j) => <li key={j} className="flex items-start gap-3 pt-2.5" data-id="element-180">
                          <span className="text-lg flex-shrink-0" data-id="element-181">
                            {item.icon}
                          </span>
                          <span className="text-sm sm:text-base text-white/95 leading-snug" data-id="element-182">
                            {item.text}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}